import React, { useState } from "react";

import { useTranslation } from "react-i18next";

function Quarte () {

      const { t } = useTranslation();

    
    return(
        <div className="max-w-[1280px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[160px] flex flex-col items-center">
            <p className="text-[#637BFF] text-[16px] xl:text-[30px] open-sans font-[800]">{t('forinvestors.5')}</p>
            <p className="open-sans text-[16px] font-[300] mt-[15px] xl:mt-[30px] xl:max-w-[872px] leading-[1.5] text-black">{t('forinvestors.6')}</p>
            <p className="open-sans text-[16px] font-[300] mt-[15px] xl:mt-[30px] xl:max-w-[872px] leading-[1.5] text-black">{t('forinvestors.7')}</p>
            <p className="open-sans text-[16px] font-[300] mt-[15px] xl:mt-[30px] xl:max-w-[872px] leading-[1.5] text-black">{t('forinvestors.8')}</p>
        </div>
    );
}

export default Quarte;